import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  selector: 'gax-page-header-description',
  templateUrl: './page-header-description.component.html',
  styleUrl: './page-header-description.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class PageHeaderDescriptionComponent {}
